import { ReplaceTriggerSpine } from 'core/display/spines/ReplaceTriggerSpine'

export default class makeReplaceTriggerSpine extends PIXI.Container{
  constructor(data) {
    super()
    const replaceTriggerSpine = new ReplaceTriggerSpine(data, this)
    this.addChild(replaceTriggerSpine)
    replaceTriggerSpine.setToSetupPose()
  }
}
